module.exports = __webpack_public_path__ + "img/language.0f9329e0.png";